import { Card, CardHeader, CardTitle, CardContent, EmptyState } from '@/components/ui'
import { AlertTriangle } from 'lucide-react'

export function DangerSettingsPage() {
  return (
    <div className="space-y-6 max-w-2xl">
      <Card className="border-[var(--error)]/30">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-[var(--error)]">
            <AlertTriangle className="h-5 w-5" />
            Danger Zone
          </CardTitle>
        </CardHeader>
        <CardContent>
          <EmptyState
            icon={AlertTriangle}
            title="Coming Soon"
            description="Export data, transfer ownership, and delete organization options will be available here."
          />
        </CardContent>
      </Card>
    </div>
  )
}
